import { render, staticRenderFns } from "./PageWorldMath.vue?vue&type=template&id=810209f6&scoped=true&"
import script from "./PageWorldMath.vue?vue&type=script&lang=js&"
export * from "./PageWorldMath.vue?vue&type=script&lang=js&"
import style0 from "./PageWorldMath.vue?vue&type=style&index=0&id=810209f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810209f6",
  null
  
)

export default component.exports